import MenuItemCardImageTop from "./MenuItemCardImageTop"
import MenuItemCardImageBottom from "./MenuItemCardImageBottom"
import MenuItemCardImageRight from "./MenuItemCardImageRight"

export const menuDevelopConfig = [
    {
        component: MenuItemCardImageRight,
        menuId:'69400825c8872138c8fbb487',
    },
    {
        component: MenuItemCardImageTop,
        menuId:'69401920c8872138c8fbd216',
    },
    {
        component: MenuItemCardImageBottom,
        menuId:'69411d8703a5eb4b5e531842',
    }
]
export const menuProductionConfig = [
    {
        component: MenuItemCardImageRight,
        menuId:'694c607771744c5bf8d5ccd6',
    },
    {
        component: MenuItemCardImageTop,
        menuId:'694c60a871744cea44d5ccf0',
    },
    {
        component: MenuItemCardImageBottom,
        menuId:'694c609971744c7185d5cce3',
    }
]
